module.exports = __webpack_public_path__ + "img/ks.aa358990.jpg";